import clsx from 'clsx';
import { withStyles } from '@material-ui/core';
import { DatePicker, MuiPickersContext } from '@material-ui/pickers';
import React, { useState, useContext, useRef } from 'react';

function DateRangePicker({
  autoOk,
  classes,
  emptyLabel,
  format,
  labelFunc,
  onChange,
  onClose,
  value,
  ...props
}) {
  const [begin, setBegin] = useState(value[0]);
  const [end, setEnd] = useState(value[1]);
  const [hover, setHover] = useState(undefined);
  const picker = useRef();
  const utils = useContext(MuiPickersContext);

  const min = Math.min(begin, end || hover);
  const max = Math.max(begin, end || hover);

  function dateSort(a, b) {
    return utils.date(a) - utils.date(b);
  }

  function renderDay(day, selectedDate, dayInCurrentMonth, dayComponent) {
    return React.cloneElement(dayComponent, {
      onClick: (e) => {
        e.stopPropagation();
        const dates =
          !begin && end
            ? [day, end].sort(dateSort)
            : begin && !end
            ? [begin, day].sort(dateSort)
            : [day, undefined];
        setBegin(dates[0]);
        setEnd(dates[1]);
        if (dates[0] && dates[1] && autoOk) {
          onChange(dates);
          picker.current.close();
        }
      },
      onMouseEnter: (e) => setHover(day),
      className: clsx(classes.day, {
        [classes.daySelected]: day >= min && day <= max,
        [classes.endCap]:
          utils.isSameDay(day, max) && !utils.isSameDay(day, min),
        [classes.singleCap]: utils.isSameDay(begin, end),
        [classes.startCap]: utils.isSameDay(day, min),
      }),
    });
  }

  const formatDate = (date) => utils.format(date, format || utils.dateFormat);
  const newEnd = end || begin;

  return (
    <DatePicker
      DialogProps={{
        className: '!z-[99999]',
      }}
      labelFunc={(date, invalid) => {
        const values = [begin, newEnd].sort(dateSort);
        return labelFunc
          ? labelFunc(values, invalid)
          : date && begin && newEnd
          ? `${formatDate(values[0])} - ${formatDate(values[1])}`
          : emptyLabel || '';
      }}
      maxDateMessage=""
      onChange={() => {}}
      onClear={() => {
        setBegin(undefined);
        setEnd(undefined);
        setHover(undefined);
        onChange([]);
      }}
      onClose={() => {
        onChange([begin, newEnd].sort(dateSort));
        if (onClose) onClose();
      }}
      renderDay={renderDay}
      value={newEnd}
      {...props}
    />
  );
}

const styles = (theme) => {
  return {
    day: {
      margin: 0,
      width: '40px',
      '&:hover': {
        backgroundColor: '#3f51b5',
        color: '#ffffff',
      },
    },
    daySelected: {
      backgroundColor: '#3f51b5',
      borderRadius: 0,
      color: '#ffffff',
    },
    endCap: {
      borderRadius: '0 50% 50% 0',
    },
    startCap: {
      borderRadius: '50% 0 0 50%',
    },
    singleCap: {
      borderRadius: '50%',
    },
  };
};

export default withStyles(styles)(DateRangePicker);
